// Export filter maps
export const knowledgeHubFilterMap = Object.freeze(
    {
        GlobalDataArticleType: 'articleType',
        GlobalDataTopic: 'topics',
        GlobalDataProduct: 'products',
        GlobalDataIndustry: 'industries'
    }
)
